/**
 * @generated SignedSource<<0f25ad2ae03e94d6ed893cd2c19bdf22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgAdminTopicsCreateSelectStoresQuery$variables = Record<PropertyKey, never>;
export type OrgAdminTopicsCreateSelectStoresQuery$data = {
  readonly organisation: {
    readonly stores: ReadonlyArray<{
      readonly allTeams: ReadonlyArray<{
        readonly id: string;
        readonly isPrivate: boolean;
        readonly " $fragmentSpreads": FragmentRefs<"OrgAdminTeamsSelector_teams" | "ReceiverStoresSelectorTeamsIndicator_teams">;
      }>;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorMain_receiverStore" | "StoreSelector_store">;
    }>;
  } | null;
};
export type OrgAdminTopicsCreateSelectStoresQuery = {
  response: OrgAdminTopicsCreateSelectStoresQuery$data;
  variables: OrgAdminTopicsCreateSelectStoresQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminTopicsCreateSelectStoresQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "stores",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "allTeams",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReceiverStoresSelectorTeamsIndicator_teams"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "OrgAdminTeamsSelector_teams"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoreSelector_store"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReceiverStoresSelectorMain_receiverStore"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgAdminTopicsCreateSelectStoresQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "stores",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "allTeams",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreTopic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "includeExternalId",
                            "value": false
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "workspaceBreadcrumbs",
                        "storageKey": "workspaceBreadcrumbs(includeExternalId:false)"
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeExternalId",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "workspaceBreadcrumbs",
                "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9c49a29ec4c9b73cdc1e9382cfdfd497",
    "id": null,
    "metadata": {},
    "name": "OrgAdminTopicsCreateSelectStoresQuery",
    "operationKind": "query",
    "text": "query OrgAdminTopicsCreateSelectStoresQuery {\n  organisation {\n    stores {\n      id\n      allTeams {\n        id\n        isPrivate\n        ...ReceiverStoresSelectorTeamsIndicator_teams\n        ...OrgAdminTeamsSelector_teams\n      }\n      ...StoreSelector_store\n      ...ReceiverStoresSelectorMain_receiverStore\n    }\n    id\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment OrgAdminTeamsSelector_teams on Team {\n  name\n  id\n  ...OrgTeamListItem_team\n}\n\nfragment OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store on Store {\n  workspaceBreadcrumbs(includeExternalId: false)\n}\n\nfragment OrgStoreWorkspaceBreadcrumbs_store on Store {\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n\nfragment OrgTeamListItem_team on Team {\n  name\n  ...AHTeamIcon\n  color\n  topics {\n    id\n    name\n  }\n  store {\n    name\n    ...OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store\n    id\n  }\n}\n\nfragment ReceiverStoresSelectorMain_receiverStore on Store {\n  id\n  name\n  ...OrgStoreWorkspaceBreadcrumbs_store\n}\n\nfragment ReceiverStoresSelectorTeamsIndicator_teams on Team {\n  id\n  name\n  ...AHTeamIconCircle\n}\n\nfragment StoreSelector_store on Store {\n  id\n  name\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n"
  }
};
})();

(node as any).hash = "0b82070f6e889efda0020b30e0aa41b3";

export default node;
